import { Controller } from '@hotwired/stimulus';

// Stimulus controller for showing a spinner while a Turbo frame loads.
// - attach to a wrapper element alongside the target frame (via frame-id-value)
// - shows the spinner target on GET requests, hides it when the frame finishes loading

export default class extends Controller {
  static targets = ['spinner'];
  static values = { frameId: String };

  connect() {
    this.frame = document.getElementById(this.frameIdValue);
    if (!this.frame) return;

    this.showSpinner = (event) => {
      if (event.detail.fetchOptions.method === 'GET') this.spinnerTarget.classList.remove('hidden');
    };
    this.hideSpinner = () => this.spinnerTarget.classList.add('hidden');

    this.frame.addEventListener('turbo:before-fetch-request', this.showSpinner);
    this.frame.addEventListener('turbo:frame-load', this.hideSpinner);
  }

  disconnect() {
    if (!this.frame) return;
    this.frame.removeEventListener('turbo:before-fetch-request', this.showSpinner);
    this.frame.removeEventListener('turbo:frame-load', this.hideSpinner);
  }
}
